import cx from 'classnames';
import moment from 'moment-timezone';

import { StarRating } from 'components/StarRating/StarRating';

import { useAppContext } from 'hooks/context/useAppContext';
import { useReview } from 'hooks/review/useReview';

import { TReview } from 'types/review';

import s from './Review.module.css';

export interface ReviewProps {
  className?: string;
  review: TReview;
}

const Review = ({ className, review }: ReviewProps) => {
  const {
    publicUser: { multi_user: isMultiUser },
  } = useAppContext();
  const reviewData = useReview({ review });
  const {
    rating,
    user_name,
    created_at,
    reviewer_name,
    isFullMessageDisplayed,
    showFullMessage,
  } = reviewData;
  const createdAt = moment(created_at).format('MM.DD.YYYY');

  return (
    <div className={cx(s.root, className)}>
      <StarRating
        value={rating}
        fillColor="var(--accent-gradient-primary)"
        fillStrokeColor="var(--accent-gradient-primary)"
        emptyColor="transparent"
        emptyStrokeColor="var(--accent-gradient-primary)"
      />
      <p>{isMultiUser ? `with ${user_name}` : null}</p>
      {reviewData.message.length > 0 && (
        <>
          <p>{reviewData.message}</p>
          {!isFullMessageDisplayed && (
            <button
              type="button"
              className={s.moreButton}
              onClick={showFullMessage}
            >
              Show More
            </button>
          )}
        </>
      )}
      <p>
        {createdAt} · {reviewer_name}
      </p>
    </div>
  );
};

export { Review };
